$(document).ready(function(){
	if($('[data-m6slidr]').length > 0) {
		$('[data-m6slidr]').m6slidr({
			beforeChange: function(item) {
				this.find('video').each(function() {
					$(this).get(0).pause();
				});

				item.find('img').lazyLoadXT({
					srcAttr: 'data-m6slidr-src'
				});

				if(item.find('video').length > 0 && breakpts.value !== 'small')
					item.find('video').get(0).play();
			}
		});
	}
});

$.fn.m6slidr = function(params) {
	return this.each(function() {
		$me = $(this);

		$me.m6slidrSettings(params);

		$me.wrap = $me.find('.m6slidr_wrap'),
		$me.originalItems = $me.wrap.find('.m6slidr_item');

		$me.originalItems.clone().addClass('m6slidr_cloned').appendTo($me.wrap);
		$me.originalItems.clone().addClass('m6slidr_cloned').prependTo($me.wrap);

		$me.m6slidrVisibleItems();

		$me.m6slidrControls();

		$me.addClass('init');

		if($me.settings.responsive) {
			$(window).resize(function() {
				$me.m6slidrSettings(params);
				$me.m6slidrVisibleItems();
			});
		}
	});
};

$.fn.m6slidrSettings = function(params) {
	// default params
	var defaults = {
		center: false,
		nbVisible: null,
		responsive: {large: {}, medium: {}, small:{} },
		onChange: function() {}
	};

	$.each(this.data(), function(key, value) {
		var match = key.match(/^(large|medium|small)/i);
		if(match) {
			newKey = key.replace(/^(large|medium|small)/i, '');
			newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);

			defaults.responsive[match[0]][newKey] = value;
		} else {
			defaults[key] = value;
		}
	});

	// extend default params
	this.settings = $.extend({}, defaults, params);

	if(this.settings.responsive[breakpts.value])
		this.settings = $.extend({}, this.settings, this.settings.responsive[breakpts.value]);

	return this;
}

$.fn.m6slidrControls = function() {
	var $me = this;

	if($me.originalItems.length == 1)
		return;

	this.append('<button type="button" class="m6slidr_control m6slidr_prev icon-left"></button>');
	this.append('<button type="button" class="m6slidr_control m6slidr_next icon-right"></button>');

	this.btn = $(this).find('.m6slidr_control');

	$(this.btn).on('click', function() {
		var direction = $(this).is('.m6slidr_next') ? 'left' : 'right';
		$me.m6slidrChange(direction);
	});

	return this;
}

$.fn.m6slidrChange = function(direction) {
	if(direction == 'right') {
		$(this.items).last().prependTo(this.wrap);
	}

	if(direction == 'left') {
		$(this.items).first().appendTo(this.wrap);
	}

	this.m6slidrVisibleItems();
	
	return this;
};

$.fn.m6slidrVisibleItems = function() {

	this.items = $(this.wrap).find('.m6slidr_item');
	$(this.items).removeClass('m6slidr_visible').removeClass('m6slidr_active');
	
	this.settings.nbVisible = this.settings.nbVisible && this.settings.nbVisible <= this.originalItems.length+1 ? this.settings.nbVisible : this.originalItems.length;
	//this.settings.nbVisible = this.settings.nbVisible%2 ? this.settings.nbVisible : this.settings.nbVisible-1;
	this.activeIndex = this.settings.center ? Math.ceil(this.settings.nbVisible/2) - 1 : 0;

	this.visibleItems = $(this.items).slice(this.originalItems.length, this.originalItems.length+this.settings.nbVisible);
	$(this.visibleItems).addClass('m6slidr_visible');

	this.activeItem = $(this.visibleItems).eq(this.activeIndex);
	this.settings.beforeChange.call(this, this.activeItem);
	$(this.activeItem).addClass('m6slidr_active');

	$(window).trigger('m6slidr:change', [this, this.activeItem]);

	this.settings.onChange.call(this, this.activeItem);

	return this;
}